import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    organisationData: {},
    creditDetailsData: {},
}

const viewOrganisationSlice = createSlice({
    name: 'viewOrganisation',
    initialState,
    reducers: {
        defaultState(state, action) {
            return initialState
        },
        setOrganisationObject(state, action) {
            return { ...state, ...action?.payload }
        },
        setCreditDetailsData(state, action) {
            return { ...state, ...action?.payload }
        },
    }
})
export const viewOrganisationActions = viewOrganisationSlice.actions;
export default viewOrganisationSlice;
